import React from 'react';
import { useSelector } from 'react-redux';
import {
  ProductItemButton,
  ProductItemSecondaryButton,
} from './multiConfigStyles';

const MultiConfigProductItemCTA = ({ item, onClick }) => {
  const { product, background, pose } = item;
  const isPrepay = useSelector((state) => state.shoot.isPrepay);

  // Handle prepay cases first
  if (isPrepay) {
    if (background) {
      return (
        <ProductItemSecondaryButton>Edit Selection</ProductItemSecondaryButton>
      );
    }

    return (
      <ProductItemButton onClick={onClick(product)}>
        Configure
      </ProductItemButton>
    );
  }

  // Handle non-prepay cases
  if (pose && background) {
    return (
      <ProductItemSecondaryButton>Edit Selection</ProductItemSecondaryButton>
    );
  }

  return (
    <ProductItemButton onClick={onClick(product)}>
      Choose Photo
    </ProductItemButton>
  );
};

export default MultiConfigProductItemCTA;
